<script setup lang="ts">
import Toast from 'primevue/toast'
import '@kinotic-ai/frontend-common'
</script>

<template>
    <main>
        <Toast />
        <router-view />
    </main>
</template>
